const features = [
  {
    icon: 'ri-4k-fill',
    title: '高清画质',
    desc: '全站支持1080P与4K超清画质，采用H.265高效编码，在保证清晰度的同时大幅降低流量消耗，让每一帧画面都细腻动人。',
  },
  {
    icon: 'ri-flashlight-fill',
    title: '秒播不缓冲',
    desc: '全球CDN节点加速覆盖，智能预加载技术确保点击即播。无论高峰时段还是弱网环境，都能享受丝滑流畅的观影体验。',
  },
  {
    icon: 'ri-vip-diamond-fill',
    title: '完全免费',
    desc: '无需注册、无需付费、无需VIP会员，所有影视资源完全免费开放。无广告打扰，纯粹观影体验，让好内容触手可及。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">为什么选择八戒影视？三大核心优势为您解答</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}